<div class="padding-20" *ngIf="show.form" id="planningCouponForm">

  <div class="infoContainer">

    <span>{{ 'campaign.date_validity' | translate }}<b>{{campaignInfo.name}}</b>: <b>{{ 'campaign.from' | translate }}
        {{ campaignInfo.dateStart | date :'dd/MM/yyyy' }} {{ 'campaign.to' | translate }} {{ campaignInfo.dateEnd | date
        : dateFormat }}</b></span>

  </div>
  <br />
  <br />
  <div class="ui-g">

    <div class="ui-g-4">
      <br />
      <br />
      <div class="title">
        <span>{{ 'campaign.coupon_period' | translate }}</span>

        <span class="asterix">*</span>&nbsp; <i class="fa fa-info-circle icon"
          pTooltip="E' l'intervallo di tempo in cui i tuoi coupon saranno distribuiti"></i>
      </div>
      <br />
      <br />
      <button class="dateButton" data-testid="emission_dates_as_campaign" (click)="onChangeAsCampaign()">
        <span style="font-size: 12px;">{{ 'campaign.set_emission_date' | translate }}</span>


      </button>
      <!--   <app-form-fields #switchAsCampaign data-testid="switchAsCampaign" [readOnly]="readOnly" [fieldSchema]="formSchema.form.come_campagna" (fieldModelChange)="onChangeAsCampaign($event)" [(fieldModel)]="switch.asCampaign"></app-form-fields> -->
      <br />
      <br />
      <app-form-fields #data_inizio_emissione data-testid="data_inizio_emissione" [readOnly]="readOnly"
        [showRequiredAsterix]="false" [(fieldModel)]="fieldModel.data_inizio_emissione" [type]="'date'"
        [placeholder]="'campaign.select_start_date_emission' | translate"
        (fieldModelChange)="onChangeInizioEmissione($event)"
        [fieldSchema]="formSchema.form.data_inizio_emissione"></app-form-fields>
      <br />
      <app-form-fields #data_fine_emissione data-testid="data_fine_emissione" [readOnly]="readOnly"
        [showRequiredAsterix]="false" [(fieldModel)]="fieldModel.data_fine_emissione" [type]="'date'"
        [fieldSchema]="formSchema.form.data_fine_emissione"
        [placeholder]="'campaign.select_end_date_emission' | translate"
        (fieldModelChange)="onChangeFineEmissione($event)"></app-form-fields>

    </div>
    <div class="ui-g-2"></div>
    <div class="ui-g-4">
      <br />
      <br />
      <div class="title">
        <span>{{ 'campaign.coupon_fruition_period' | translate }}</span>

        <span class="asterix">*</span>&nbsp; <i class="fa fa-info-circle icon"
          pTooltip="E' l'intervallo di tempo in cui i tuoi coupon saranno fruibili in cassa"></i>
      </div>
      <br />
      <br />
      <div class="d-flex flex-row">
        <span class="switchTitle input-switch-container" id="switchAsEmission">
          <button class="dateButton" data-testid="fruition_dates_as_emission" (click)="onChangeAsEmission()">
            <span>{{ 'campaign.as_emission' | translate }}</span>

          </button>

 &nbsp;
          <app-form-fields #switchVariable data-testid="switchVariable" [readOnly]="readOnly"
            [fieldSchema]="formSchema.form.variabili" (fieldModelChange)="onChangeVariable($event)"
            [(fieldModel)]="switch.variable"></app-form-fields>

        </span>
      </div>
      <br />
      <br />
      <div class="" *ngIf="switch.variable == false">
        <app-form-fields #data_inizio_fruizione data-testid="data_inizio_fruizione" [readOnly]="readOnly"
          [fieldSchema]="formSchema.form.data_inizio_fruizione" [showRequiredAsterix]="false"
          [(fieldModel)]="fieldModel.data_inizio_fruizione" [type]="'date'"
          [placeholder]="'campaign.select_start_date_fruition' | translate"
          (fieldModelChange)="onChangeInizioFruizione($event)"></app-form-fields>

        <br />

        <app-form-fields #data_fine_fruizione data-testid="data_fine_fruizione" [readOnly]="readOnly"
          [fieldSchema]="formSchema.form.data_fine_fruizione" [showRequiredAsterix]="false"
          [(fieldModel)]="fieldModel.data_fine_fruizione" [type]="'date'"
          [placeholder]="'campaign.select_end_date_fruition' | translate"></app-form-fields>
      </div>
        <div class="" *ngIf="switch.variable == true">

          <!-- INIZIO FRUIZIONE -->

          <!-- combo modalità di inizio fruizione -->
          <!-- combo modalità di inizio fruizione -->
          <app-form-fields #modalita_inizio_fruizione data-testid="modalita_inizio_fruizione" [readOnly]="readOnly"
            [fieldSchema]="formSchema.form.modalita_inizio_fruizione" [showRequiredAsterix]="false"
            [(fieldModel)]="fieldModel.modalita_inizio_fruizione" [type]="'dropdown'" [options]="comboInizioFruizione"
            [optionLabel]="'description'" [placeholder]="'campaign.select_start_fruition_mode' | translate"
            (fieldModelChange)="onChangeModalitaInizioFruizione($event)"></app-form-fields>
          <br />


          <!-- visibile solo in caso di scelta "Generazione + offset "-->
          <app-form-fields *ngIf="show.offsetInizioFruizione"
            (fieldModelChange)="onChangeModalitaOffsetStartFruizione($event)" [readOnly]="readOnly"
            [fieldSchema]="formSchema.form.offset_inizio_fruizione" #offset_inizio_fruizione
            data-testid="offset_inizio_fruizione" [(fieldModel)]="fieldModel.offset_inizio_fruizione" [type]="'number'"
            class="offsetInput" (fieldModelChange)="onChangeOffsetInizioFruizione($event)"></app-form-fields>
          <br *ngIf="show.offsetInizioFruizione" />

          <!-- combo giorno della settimana inizio fruizione -->
          <div class="ui-g giornoSettimana" *ngIf="show.giorno_settimana_inizio"
            [ngClass]="{'formHidden': formSchema.form.giorno_settimana_inizio.visible == false }">
            <div class="ui-g-4">{{formSchema.form.giorno_settimana_inizio.label[language]}}</div>
            <div class="ui-g-8">
              <app-form-fields #giorno_settimana_inizio data-testid="giorno_settimana_inizio" [showLabel]="false"
                [readOnly]="readOnly" [fieldSchema]="formSchema.form.giorno_settimana_inizio"
                [showRequiredAsterix]="false" (fieldModelChange)="onChangeGiornoSettimana()"
                [(fieldModel)]="fieldModel.giorno_settimana_inizio" [label]=""
                [placeholder]="'campaign.select_start_day' | translate"></app-form-fields>

            </div>
            <br />
          </div>
          <br *ngIf="show.giorno_settimana_inizio" />


          <!-- visibile solo in caso di scelta "Data fissa" -->
          <app-form-fields *ngIf="show.fissaInizioFruizione" #data_inizio_fruizione_fissa
            data-testid="data_inizio_fruizione_fissa" [readOnly]="readOnly"
            [fieldSchema]="formSchema.form.data_inizio_fruizione_fissa" [showRequiredAsterix]="false"
            [(fieldModel)]="fieldModel.data_inizio_fruizione_fissa"
            [placeholder]="'campaign.select_fixed_start_date_fruition' | translate"
            (fieldModelChange)="onChangeInizioFruizioneFissa($event)"></app-form-fields>

          <br *ngIf="show.fissaInizioFruizione" />

          <!-- FINE FRUIZIONE -->

          <!-- combo modalità di fine fruizione -->
          <app-form-fields #modalita_fine_fruizione data-testid="modalita_fine_fruizione" [readOnly]="readOnly"
            [fieldSchema]="formSchema.form.modalita_fine_fruizione" [showRequiredAsterix]="false"
            [(fieldModel)]="fieldModel.modalita_fine_fruizione" [options]="comboFineFruizione"
            [optionLabel]="'description'" [placeholder]="'campaign.select_end_mode_fruition' | translate"
            (fieldModelChange)="onChangeModalitaFineFruizione($event)"></app-form-fields>

          <br />

          <!-- visibile solo in caso di scelta "Generazione + offset "-->
          <app-form-fields *ngIf="show.offsetFineFruizione" #offset_fine_fruizione data-testid="offset_fine_fruizione"
            (fieldModelChange)="onChangeModalitaOffsetFineFruizione($event)" [readOnly]="readOnly"
            [fieldSchema]="formSchema.form.offset_fine_fruizione" [showRequiredAsterix]="false"
            [(fieldModel)]="fieldModel.offset_fine_fruizione" class="offsetInput"></app-form-fields>
          <br *ngIf="show.offsetFineFruizione" />


          <!-- combo giorno della settimana inizio fruizione -->
          <div class="ui-g giornoSettimana" *ngIf="show.giorno_settimana_fine"
            [ngClass]="{'formHidden': formSchema.form.giorno_settimana_fine.visible == false }">
            <div class="ui-g-4">{{formSchema.form.giorno_settimana_fine.label[language]}}</div>
            <div class="ui-g-8">
              <app-form-fields #giorno_settimana_fine [showLabel]="false" [readOnly]="readOnly"
                [fieldSchema]="formSchema.form.giorno_settimana_fine" [showRequiredAsterix]="false"
                (fieldModelChange)="onChangeGiornoSettimana()" [(fieldModel)]="fieldModel.giorno_settimana_fine"
                [placeholder]="'campaign.select_week_day_end' | translate"></app-form-fields>

            </div>
            <br />
          </div>
          <br *ngIf="show.giorno_settimana_fine" />

          <!-- visibile solo in caso di scelta "Data fissa" -->
          <app-form-fields #data_fine_fruizione_fissa *ngIf="show.fissaFineFruizione" [readOnly]="readOnly"
            [fieldSchema]="formSchema.form.data_fine_fruizione_fissa" [showRequiredAsterix]="false"
            [(fieldModel)]="fieldModel.data_fine_fruizione_fissa"
            [placeholder]="'campaign.select_fixed_end_date_fruition' | translate"
            (fieldModelChange)="onChangeFineFruizioneFissa($event)"></app-form-fields>


        </div>

      </div>
      <br />
      <br />
      <div class="errorDate" *ngIf="show.errorDate==true">
        <span *ngIf="language == 'it'">{{errorDateText}}</span>
        <span *ngIf="language == 'en'">{{errorDateText}}</span>
      </div>

    </div>
    <br />

  </div>



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/views/campaign-3-planning/campaign-3-planning.component.html